import type { ChangelogEntry } from "../types";

/** VIB-3050 PR 3a: bookerkø med lavvann og høyvann, og nye regler for nytt forsøk. */
export const LEADS_BOOKERKO_2026_11: ChangelogEntry = {
  id: "2026-11-03-leads-bookerko",
  date: "2026-11-03",
  title: "Hver booker har en egen kø, og reglene for nytt forsøk vises i appen",
  summary:
    "Køen fylles fra poolene til 30 leads når du har færre enn 10 som kan ringes. «Ikke svar» første gang gir deg leadet igjen etter 3 timer, andre gang går det tilbake til poolen. «Slik fordeles leads» viser reglene med tallene systemet bruker.",
  sections: [
    {
      heading: "Leads",
      items: [
        {
          title: "Køen din",
          kind: "nytt",
          body: "Øverst står hvor mange leads du kan ringe nå. Har du færre enn lavvann, fylles køen opp til høyvann fra poolene dine. Leads i køen er dine til du booker møte eller avviser dem.",
        },
        {
          title: "Hvorfor leadet kommer nå",
          kind: "nytt",
          body: "Leadkortet sier øverst hvorfor leadet kommer, for eksempel «Andre forsøk» eller «Du lovet å ringe tilbake», og hva som skjer ved neste utfall.",
        },
        {
          title: "Nye regler for «Ikke svar» og e-post",
          kind: "forbedret",
          body: "Første «Ikke svar» gir deg leadet igjen tidligst 3 timer senere, eller neste morgen hvis du ringte etter kl. 13. Andre gang går leadet tilbake til poolen og hviler i 2 dager. «Sendt e-post» følges opp etter 3 virkedager i stedet for en uke.",
        },
        {
          title: "Slik fordeles leads",
          kind: "nytt",
          body: "Knappen øverst i Leads og Leadlister viser alle reglene, med de samme tallene systemet bruker.",
        },
      ],
    },
    {
      heading: "Leadlister",
      items: [
        {
          title: "Bookerne og køene deres",
          kind: "nytt",
          body: "Hver møtebooker har et kort med køen mot lavvann og høyvann, og hvilke pooler den fylles fra. Klikk kortet for å velge pooler og overstyre lavvann og høyvann.",
          minRole: "admin",
        },
      ],
    },
  ],
};
